import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignActivityInfo } from '@hooks-api/fortune/useApiCampaignActivityInfo'
import { Button } from '@pets-ui/Button/Button'
import { NoticeOutlined } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useHistory } from 'react-router-dom-v5'

export function NotFound() {
  const history = useHistory()
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: activityInfo } = useApiCampaignActivityInfo(campaignCodeFromUrl)

  const handleClick = () => {
    const hasCampaign = !!activityInfo
    if (hasCampaign) {
      history.push(`/campaigns/${campaignCodeFromUrl}`)
    }
    else {
      history.push('/')
    }
  }

  return (
    <VStack gap={5} p={4} height="100vh" alignItems="center" justifyContent="center">
      <NoticeOutlined fontSize={72} color={colors.red600} />
      <Text variant="subtitle">發生錯誤 (404)，抱歉此頁面不存在</Text>
      <Button onClick={handleClick}>回到首頁</Button>
    </VStack>
  )
}
